export default "__VITE_ASSET__BsRuUvLU__"